// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Form, Button, Input, Icon } from 'antd';
import { GlobalFooter } from 'slide-new-toolkit';
import styles from './Login.less';
import { Auth } from '../../models';
import { askForPermissioToReceiveNotifications } from '../../push-notification';

const FormItem = Form.Item;

const mapStateToProps = (state) => {
  const { auth } = state;
  return {
    auth,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({ login: Auth.login }, dispatch);


class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 'account',
    };
  }

  componentDidMount() {
    if (this.props.auth && this.props.auth.isLogged === true) {
      this.props.history.push('/');
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.auth && this.props.auth.isLogged === false && nextProps.auth.isLogged === true) {
      this.props.history.push('/');
    }
  }

  changeHandle = (formData) => {
    console.log('changeHandle: ', formData);
    // this.setState({
    //   formData,
    // });
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    // const { type } = this.state;

    let token = await askForPermissioToReceiveNotifications();

    this.props.form.validateFields(
      { force: true },
      (err, values) => {
        if (!err) {
          this.props.login({
            formData: {
              ...values,
              token,
            },
          });
        }
      },
    );
  }
  render() {
    const { form: { getFieldDecorator }, auth } = this.props;
    const { type } = this.state;
    return (
      <div className={styles.container}>
        <div className={styles.top}>
          <div className={styles.header}>
            <img alt="" className={styles.logo} src="https://s3-us-west-1.amazonaws.com/ubinfo-s3/fun/a7b74770-e088-11e7-931a-e13cc153fd5d.jpg" />
            <span className={styles.title}>UBinfo</span>
          </div>
          <div className={styles.desc}>Vendor Management</div>
        </div>
        <div className={styles.main}>
          <Form onSubmit={this.handleSubmit}>
            <FormItem>
              {getFieldDecorator('email', {
            rules: [{
              required: type === 'account', message: 'Нэвтрэх нэр оруулна уу！',
            }],
          })(<Input
            size="large"
            prefix={<Icon type="user" className={styles.prefixIcon} />}
            placeholder="Нэвтрэх нэр"
          />)}
            </FormItem>
            <FormItem>
              {getFieldDecorator('password', {
            rules: [{
              required: type === 'account', message: 'Нууц үг оруулна уу',
            }],
          })(<Input
            size="large"
            prefix={<Icon type="lock" className={styles.prefixIcon} />}
            type="password"
            placeholder="Нууц үг"
          />)}
            </FormItem>
            <FormItem className={styles.additional}>
              <Button size="large" loading={auth.isLoading} className={styles.submit} type="primary" htmlType="submit">
                Нэвтрэх
              </Button>
            </FormItem>
          </Form>
        </div>
        <GlobalFooter
          className={styles.footer}
          copyright={
            <div>
              Copyright <Icon type="copyright" /> 2018 Slide Ltd
            </div>
          }
        />
      </div>
    );
  }
}

Login.propTypes = {
  auth: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const WrappedNormalLoginForm = Form.create()(Login);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(WrappedNormalLoginForm);



// WEBPACK FOOTER //
// ./src/containers/Login/index.js